import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'

import Icon from '../icon/index'
import ArrowDown from '../icon/chevron-down.svg'
import Lock from '../icon/lock.svg'

import styles from '../../../styles/bantrab/components/card.module.scss'

const CourseSmallDefault = ({ classes, idLabel, ...attrs }) => {
  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.courseSmallDefault]: true
  })

  return (
    <div {...attrs}>
      <input id="idLabel" type="checkbox" />
      <label htmlFor="idLabel" className="cursor-pointer">
        <Typography tag="h1" size="four" className="text-gray-600">Introducción</Typography>
        <figure>
          <Icon svg={ArrowDown} size="24" className="text-green-500" />
        </figure>
      </label>
      <ul className="mt-4">
        {
          classes.map((item, index) => {
            return (
              <li className="flex items-center justify-between mb-1" key={index}>
                <Typography tag="h4" size="four">{item.number}. {item.text}</Typography>
                <Icon className="text-gray-400" svg={Lock} size={24} />
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

CourseSmallDefault.propTypes = {
  classes: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  idLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default CourseSmallDefault
